import {
  Box,
  Card,
  CardContent,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

export default function TeamPricingCard({
  config,
  disabled,
  onPriceChange,
  onTrialDurationChange,
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box className="flex items-center gap-2 mb-4">
          <Box
            sx={{
              width: 8,
              height: 40,
              borderRadius: "4px",
              bgcolor: "#1F4FFF",
            }}
          />
          <Typography variant="h6" className="font-bold text-slate-900">
            Team Pricing
          </Typography>
        </Box>

        <Box className="space-y-4">
          <TextField
            fullWidth
            label="Price Per Team Member"
            value={config.pricePerTeamMember}
            onChange={onPriceChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">₦</InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">/month</InputAdornment>
              ),
            }}
            helperText="Monthly price charged for each team member"
            disabled={disabled}
          />

          <Divider sx={{ my: 2 }} />

          <TextField
            fullWidth
            label="Seat Trial Duration"
            type="number"
            value={config.trialDurationDays}
            onChange={onTrialDurationChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">days</InputAdornment>
              ),
            }}
            helperText="Trial period in days for team seats"
            disabled={disabled}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
